import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useLoanStore } from "@roc/feature-loans";
import { useUserStore } from "@roc/feature-app-core";
import { VirtualScroll } from "./components/common/virtualScroll";
import { Box } from "@material-ui/core";
import { ManualQuoteTab } from "./tabs/manualQuoteTab";
import { useStore } from "@roc/client-portal-shared/hooks";

export const ManualQuoteTabInternal = observer(() => {
  const { loanStore } = useLoanStore();
  const { userStore } = useUserStore();
  const { globalStore } = useStore();
  const { loanId } = useParams<{ loanId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const numericLoanId = Number(loanId);


  const fetchLoanDetails = async () => {
    if (numericLoanId) {
      await loanStore.fetchLoanDetails(numericLoanId, () => {
        setIsLoading(false);
      });
    }
    userStore.getUserInfoAndEntitlements(() => {
      globalStore.lenderInfo = {
        ...globalStore.lenderInfo,
        lenderId: loanStore.loanDetails.lenderId,
        isInternal: loanStore.loanDetails?.manualQuoteLoanDetailValues?.internalLender
      }
      setIsLoadingUser(false)
    });
  };

  useEffect(() => {
    if (numericLoanId) {
      fetchLoanDetails();
    }
  }, [loanStore, numericLoanId]);

  return (isLoading || isLoadingUser) ? (<div>Loading...</div>) : (
    <VirtualScroll>
      <Box style={{ maxHeight: '970px', overflowY: 'auto' }}>
        <ManualQuoteTab source={"nportal"} />
      </Box>
    </VirtualScroll>
  );
});
